<template>
    <b-card>
        <div v-if="loading" class="loading"/>

        <div class="mb-2 mt-2">
            <div class="d-block d-md-inline-block pt-1">
                <h4 class="mb-2 card-title">List of Admissions</h4>
            </div>

            <div class="float-md-right pt-1">
                <span class="text-muted text-small mr-1 mb-2">{{ meta.from }}-{{ meta.to }} of {{ meta.total }}</span>
                <b-dropdown id="ddown2" right :text="`${meta.per_page}`" variant="outline-dark"
                            class="d-inline-block" size="xs">
                    <b-dropdown-item v-for="(size,index) in meta.page_sizes" :key="index"
                                     @click="changePageSize(size)">{{ size }}
                    </b-dropdown-item>
                </b-dropdown>
            </div>
        </div>

        <b-table show-empty no-sort-reset class="vuetable" :current-page="meta.current_page" :per-page="meta.per_page"
                 :fields="table.fields" :items="fetchVendorAdmissions">
            <template v-slot:cell(code)="data">
                <span v-text="data.item.data.attributes.code"/>
            </template>

            <template v-slot:cell(client_id)="data">
                <router-link class="text-data-link" :to="data.item.data.attributes.client_link"
                             v-text="data.item.data.attributes.client"/>
            </template>

            <template v-slot:cell(facility)="data">
                <span v-text="data.item.data.attributes.facility"/>
            </template>

            <template v-slot:cell(unit)="data">
                <span v-text="data.item.data.attributes.unit"/>
            </template>

            <template v-slot:cell(move_in)="data">
                <span v-text="data.item.data.attributes.move_in"/>
            </template>

            <template v-slot:cell(move_out)="data">
                <span v-text="data.item.data.attributes.move_out"/>
            </template>

            <template v-slot:cell(staying_for)="data">
                <span v-text="data.item.data.attributes.staying_for"/>
            </template>

            <template v-slot:cell(status)="data">
                <b-badge pill style="width: 73px;"
                         :variant="data.item.data.attributes.status === 'Admitted' ? 'info' : 'danger'">
                    {{ data.item.data.attributes.status }}</b-badge>
            </template>
        </b-table>

        <b-pagination size="sm" align="center" :total-rows="meta.total" :per-page="meta.per_page"
                      v-model="meta.current_page">
            <template v-slot:next-text>
                <i class="simple-icon-arrow-right"/>
            </template>

            <template v-slot:prev-text>
                <i class="simple-icon-arrow-left"/>
            </template>

            <template v-slot:first-text>
                <i class="simple-icon-control-start"/>
            </template>

            <template v-slot:last-text>
                <i class="simple-icon-control-end"/>
            </template>
        </b-pagination>
    </b-card>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        name: "VendorAdmissionsList",
        data() {
            return {
                loading: false,
                table: {
                    fields: [
                        {key: 'code', label: 'Code'},
                        {key: 'client_id', label: 'Client'},
                        {key: 'facility', label: 'Facility', tdClass: 'text-muted'},
                        {key: 'unit', label: 'Unit', tdClass: 'text-muted'},
                        {key: 'move_in', label: 'Move In', tdClass: 'text-muted'},
                        {key: 'move_out', label: 'Move Out', tdClass: 'text-muted'},
                        {key: 'staying_for', label: 'Staying For', tdClass: 'text-muted'},
                        {key: 'status', label: 'Status', thClass: 'text-center', tdClass: 'text-center'},
                    ]
                }
            }
        },

        computed: {
            ...mapGetters({
                meta: 'getVendorAdmissionsMeta',
            }),
        },

        methods: {
            changePageSize(per_page) {
                this.meta.per_page = per_page;
            },

            fetchVendorAdmissions() {
                return this.$store.dispatch('fetchVendorAdmissions', this.$route.params.vendor_id)
                    .then(admissions => {
                        return admissions.data;
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },
        }
    }
</script>

<style scoped>

</style>
